import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Location } from '@core/interfaces';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';
import { sentry } from 'sentry';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';

const SEARCH_QUERY = gql`
  query searchLocations($where: LocationWhereInput) {
    locations(
      where: $where
      orderBy: {
        column: name,
        direction: asc
      }
      limit: 10
      offset: 0
    ){
      items {
        id
        name
        address {
          formattedAddress,
          postalCode,
          streetName,
          city,
          number,
          complement,
          neighborhood,
          state,
          coords {
            latitude,
            longitude
          }
        }
      }
    }
  }
`;

@Component({
  selector: 'fc-location-input',
  templateUrl: './fc-location-input.component.html',
  styleUrls: ['./fc-location-input.component.scss']
})
export class FcLocationInputComponent {
  @Input()
  public control: FormControl;

  @Input()
  public showSearchIcon = false;

  @Input()
  public requiredMark = false;

  @Input()
  public preloadOptions = false;

  @Input()
  public searchOnFocus = false;

  @Input()
  public label = null;

  @Input()
  public translateErrorPrefix: string;

  constructor(
    private readonly fuseTranslationLoaderService: FuseTranslationLoaderService,
    private readonly apollo: Apollo
  ) {
    this.fuseTranslationLoaderService.loadJsonTranslations({ english, portuguese, spanish });
    this.search = this.search.bind(this);
    this.displayWith = this.displayWith.bind(this);
  }

  async search(searchTerm: string): Promise<any[]> {
    return this.apollo
      .query({
        query: SEARCH_QUERY,
        variables: {
          where: {
            formattedAddressOrDocumentNumber_contains: searchTerm,
            archived: false
          },
        },
      })
      .toPromise()
      .then((result) => {
        return result.data['locations']['items'];
      })
      .catch((err) => {
        sentry.captureException(err);
        return [];
      });
  }

  displayWith(value: Location): string {
    return value && value.address && value.address.formattedAddress;
  }
}
